import type { ThemeConfig } from 'antd'

const token: ThemeConfig['token'] = {
  colorPrimary: '#7f45e5',
}

const components: ThemeConfig['components'] = {
  Tabs: {
    horizontalItemGutter: 16,
    horizontalMargin: '0 0 24px 0',
    horizontalItemPaddingSM: '4px 0',
  },
}

export const themeConfig: ThemeConfig = {
  token,
  components,
  cssVar: true,
  hashed: false,
}
